import React from 'react'
import { Skeleton, Stack } from '@mui/material';

export const CuestionSkeleton = () => {
    return (
        <Stack
            direction={{ xs: 'column', sm: 'column', md: 'row' }}
            justifyContent="center"
            alignItems="center"
            spacing={1}
            marginTop={20}
        >
            <Skeleton variant='rectangular' width={500} height={400} animation="wave" />
        </Stack>
    )
}
